/**
 * Resolves a Strapi media relative URL to an absolute URL.
 *
 * - Returns null if relativeUrl is falsy (missing media = hide element).
 * - Returns relativeUrl as-is if it starts with 'http' (already absolute,
 *   handles Strapi Cloud CDN case).
 * - Otherwise prepends the Strapi base URL.
 */
export function resolveStrapiMediaUrl(
  baseUrl: string,
  relativeUrl: string | null | undefined,
): string | null {
  if (!relativeUrl) return null;
  if (relativeUrl.startsWith('http')) return relativeUrl;
  return `${baseUrl}${relativeUrl}`;
}
